import React, { useState, useContext, useEffect } from 'react';
import Banner from '../../component/Common/Banner'
import { connect } from "react-redux";

import { AuthContext } from '../../context/AuthContext';
import * as actions from "../../actions/order";
import * as user from "../../actions/user";
import moment from 'moment';
import API from '../../utils/api';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Appointments = (props) => {
  const { t, i18n } = useTranslation();
  const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
  const authUser = getAuthUser()

  const [isOrderTab, setIsOrderTab] = useState(true);
  const [docBookings, setDocBookings] = useState([]);
  const [tab, setTab] = useState(11);

  useEffect(() => {
    props.getMyOrders(authUser.id);
    if (props?.route?.params?.enableDocTab) {
      setIsOrderTab(false)
      setTab(12)
    } else {
      setTab(11)
    }

    API.doctorbooking().getMyBookings({
      customer: authUser.id
    })
      .then(res => {

        setDocBookings(res.data)
      })
      .catch(err => console.log(err))

  }, []);


  return (
    <>
      <Banner title={t('appointments')} />
      <div className='container mt-5'>
        <div className='row'>
          <div className="col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard_tab_button">
              <ul role="tablist" className="nav flex-column dashboard-list">
                <li><a onClick={() => setTab(11)} className={tab===11 ? 'bg-eve' : null}>{t('padibookings')}</a></li>
                <li><a onClick={() => setTab(12)} className={tab===12 ? 'bg-eve' : null}>{t('doctorbookings')}</a></li>
                <li><a onClick={() => setTab(13)} className={tab===13 ? 'bg-eve' : null}>{t('treatmnetbookings')}</a></li>

              </ul>
            </div>
          </div>

          {tab===11 &&

            <div className="col-sm-12 col-md-9 col-lg-9">
              <div>
                {props.orders?.length ? props.orders.map((currentOrder, index) => (

                  <div className="card mb-5" key={index}>
                    <div className="card-body">

                      <h5 className='mb-3'>{t('yourorderid')} : {'#' + currentOrder.orderID} <span className='badge badge-success text-capitalize font-weight-light ml-2'> {currentOrder.order_status} </span> <a className='float-right'> {t('orderedon')} {moment(currentOrder.createdDate).format("DD MMM yy LT")}</a></h5>
                      <div className='row'>
                        <div className='col-lg-5'>

                          <p className='small'>{t('transactionamt')}: {currentOrder.transaction_amount}</p>
                          <p className='small'>{t('transactionno')}. {currentOrder.transaction_no}</p>
                          <p className='small'>{t('earnedpts')}. {currentOrder.rewardPoints}</p>
                          <a target='_blank' href={process.env.REACT_APP_IMG_URL + 'view-invoice/invoice_' + currentOrder.orderID + '.pdf'}>{t('downloadinvoice')}</a>


                        </div>
                        <div className='col-lg-7'>

                          {currentOrder.orderedServicesRef.map((item, i) =>

                          (


                            <div className='row mb-3' key={i}>
                              <div className='col-lg-4'>
                                <img src={process.env.REACT_APP_IMG_URL + item?.key?.image} style={{ height: '100px', width: '100px', objectFit: 'cover' }} />
                              </div>
                              <div className='col-lg-8'>
                                <p className='font-weight-bold'>{item?.key?.title[i18n.language]}</p>

                                <p className='mb-1'>{t('quantity')}: {currentOrder.orderedServices[item.key.id]}</p>
                                {item.key.type === 'product' && <span className='discount badge cart-label font-weight-light text-capitalize'>{t('treatment')}</span>}
                                {item.key.type === 'item' && <span className='discount badge cart-label font-weight-light text-capitalize'>{t('product')}</span>}
                                {item.key.type === 'package' && <span className='discount badge cart-label font-weight-light text-capitalize mb-2'>{t('package')}</span>}
                                {item.key.type === 'coupon' && <span className='discount badge cart-label font-weight-light text-capitalize'>{t('deal')}</span>}
                                {
                                  item.key.type !== 'package' && item.key.type != 'item' && item?.key.id && typeof currentOrder?.scheduledServices != "undefined" && Object.keys(currentOrder.scheduledServices).length > 0 &&

                                  Array(currentOrder?.orderedServices[item?.key?.id]).fill().map((e, i) => (
                                    Object.keys(currentOrder.scheduledServices).length > 0 &&
                                    <div style={{ flexDirection: 'row' }} key={i}>
                                      <div style={{ justifyContent: 'center' }}>
                                        {item.key.id && typeof currentOrder?.scheduledServices[item.key.id] != "undefined" && <p className='small text-adam'>{t('booking')} {i + 1}.  {moment(currentOrder?.scheduledServices[item.key.id][0]?.date).format("DD MMM yy")}  {moment(currentOrder?.scheduledServices[item.key.id][i]?.time, 'hh:mm a').format('hh:mm A')}</p>}
                                      </div>
                                    </div>
                                  ))

                                }




                                {item.key.type === 'package' && item.key.packageServices &&
                                  item.key.packageServices.map((et, i) => (
                                    <div className='mb-2' key={i}>

                                      <div className='row'>
                                        <div className='col-lg-3'>
                                          <img src={process.env.REACT_APP_IMG_URL + et?.serviceID?.image} style={{
                                            height: 50, width: 50, objectFit: 'cover'
                                          }} />
                                        </div>
                                        <div className='col-lg-9'>
                                          <p>{et?.serviceID?.title[i18n.language]}</p>
                                          {currentOrder?.scheduledServices[item.key.id][et?.serviceID?.id]?.map((dt, i) => (
                                            <>
                                              <p className='small text-adam'>Booking {i + 1}.  {dt.date} {dt.time}</p>
                                            </>
                                          ))

                                          }


                                        </div>
                                      </div>



                                    </div>

                                  ))
                                }




                              </div>

                            </div>
                          ))}
                        </div>

                      </div>



                    </div>
                  </div>


                )) :
                  <div className="erorr_wrapper mb-5">

                    <i className="fa fa-search-minus fa-5x text-dark" aria-hidden="true"></i>

                    <h3 className='text-dark'>Sorry, No data available here</h3>

                    {/* <Link to="/" className="theme-btn-one btn-black-overlay btn_md">Back To Home Page</Link> */}
                  </div>

                }
              </div>
            </div> }
{tab===12 &&
            <div className="col-sm-12 col-md-12 col-lg-9">

              {docBookings.length ?
                docBookings.filter(e=>e.type==='doctor').map((item, index) => (
                  <div className="card mb-4" key={index}>
                    <div className="card-body">
                      {/* Order ID: {'#'+item.orderID} */}
                      {/* <h5 className='mb-3'> <a className='float-right'>Ordered on {moment(item.createdDate).format("DD MMM yy LT")}</a></h5> */}

                      <div className='row'>
                      <div className='col-lg-8 col-12'>
                      {item?.doctor?.map((doctor, i) => (
                        <div className='row' key={i}>
                        <div className='col-2'>
                          <img src={process.env.REACT_APP_IMG_URL + doctor.image} style={{ height: '70px', width: '70px', objectFit: 'cover' }} />
                        </div>
                        <div className='col-10'>
                          <p className='text-adam font-weight-bold mb-2'>{doctor?.name[i18n.language]}</p>
                          <p>{t('appdate')}: {moment(item.bookingDate).format("DD MMM yy LT")}</p>
                          {item?.services?.map((service, i) => (
                       <p className='mt-2'>{t('treatment')}: <img src={process.env.REACT_APP_IMG_URL + service.image} style={{ height: '20px', width: '20px', objectFit: 'cover', marginRight:5 }} /> {service?.title[i18n.language]}</p>))}
                    
                        </div>

                      </div>))}
                      </div>
                      <div className='col-lg-4 col-12'>
                      
                          <p>{t('status')}: <span className='discount badge cart-label font-weight-light text-capitalize'>{`${item.status}`}</span></p>
                        
                          <small> {t('orderedon')} {moment(item.createdDate).format("DD MMM yy LT")}</small>
                   
                     
                        
                      </div>
                      
                        </div>
                     
                     
                      

                    </div>
                  </div>
                )) :
                <div className="erorr_wrapper mb-5">

                  <i className="fa fa-search-minus fa-5x text-dark" aria-hidden="true"></i>

                  <h3 className='text-dark'>Sorry, No data available here</h3>

                  {/* <Link to="/" className="theme-btn-one btn-black-overlay btn_md">Back To Home Page</Link> */}
                </div>}

            </div>
          }

{tab===13 &&
            <div className="col-sm-12 col-md-12 col-lg-9">

              {docBookings.length ?
                docBookings.filter(e=>e.type==='treatment').map((item, index) => (
                  <div className="card mb-4" key={index}>
                    <div className="card-body">
                      {/* Order ID: {'#'+item.orderID} */}
                      {/* <h5 className='mb-3'> <a className='float-right'>Ordered on {moment(item.createdDate).format("DD MMM yy LT")}</a></h5> */}

                      <div className='row'>
                      <div className='col-lg-8 col-12'>
                      {item?.services?.map((service, i) => (
                        <div className='row' key={i}>
                        <div className='col-3'>
                          <img src={process.env.REACT_APP_IMG_URL + service.image} style={{ height: '100px', width: '100px', objectFit: 'cover' }} />
                        </div>
                        <div className='col-lg-9'>
                          <p className='text-adam font-weight-bold mb-2'>{service?.title[i18n.language]}</p>
                          <p>{t('appdate')}: {moment(item.bookingDate).format("DD MMM yy LT")}</p>
                          {item?.doctor?.map((doctor, i) => (
                       <p className='mt-2'>{t('doctor')}: <img src={process.env.REACT_APP_IMG_URL + doctor.image} style={{ height: '20px', width: '20px', objectFit: 'cover', marginRight:5 }} /> {doctor?.name[i18n.language]}</p>))}
                    
                        </div>

                      </div>))}
                      </div>
                      <div className='col-lg-4 col-12'>
                      
                          <p>{t('status')}: <span className='discount badge cart-label font-weight-light text-capitalize'>{`${item.status}`}</span></p>
                        
                          <small> {t('orderedon')} {moment(item.createdDate).format("DD MMM yy LT")}</small>
                   
                     
                        
                      </div>
                      
                        </div>
                     
                     
                      

                    </div>
                  </div>
                )) :
                <div className="erorr_wrapper mb-5">

                  <i className="fa fa-search-minus fa-5x text-dark" aria-hidden="true"></i>

                  <h3 className='text-dark'>Sorry, No data available here</h3>

                  {/* <Link to="/" className="theme-btn-one btn-black-overlay btn_md">Back To Home Page</Link> */}
                </div>}

            </div>
          }
        </div>
      </div>


    </>
  )
}


const mapStateToProps = state => ({
  orders: state?.order?.orders,
  meta: state?.order?.metaOrder,
  checkoutCart: state.users?.checkoutCart
})

const mapActionToProps = {

  getMyOrders: actions.getMyOrders,
  update: actions.update,
  getCart: user.getCart,
}

export default connect(mapStateToProps, mapActionToProps)(Appointments);


